import type { FeatureFlags } from './useFeatureFlags';
import useFeatureFlags, { featureFlags } from './useFeatureFlags';

export type { FeatureFlags };
export { featureFlags };
export default useFeatureFlags;
